export default [
    'Cannot generate DCs - there are no plans for this month.',
    'Cannot generate DCs - there are no PO numbers defined for this month.',
    'Cannot generate DCs - Generation is not allowed.',
    'All DCs were already generated for this month.',
    'No actuals'
];